exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-about-tsx": () => import("./../../../src/pages/about.tsx" /* webpackChunkName: "component---src-pages-about-tsx" */),
  "component---src-templates-index-tsx": () => import("./../../../src/templates/Index.tsx" /* webpackChunkName: "component---src-templates-index-tsx" */),
  "component---src-templates-post-template-tsx": () => import("./../../../src/templates/PostTemplate.tsx" /* webpackChunkName: "component---src-templates-post-template-tsx" */)
}

